import { useState, useEffect } from 'react';

const ModalCotizar = ({ 
  showModal, 
  onClose, 
  nuevaCotizacion,     // Props opcionales para compatibilidad
  onInputChange,       // Props opcionales para compatibilidad  
  onSubmit 
}) => {

  const [localCotizacion, setLocalCotizacion] = useState('');
  const [localComentario, setLocalComentario] = useState('');

  const useExternalState = nuevaCotizacion && onInputChange;

  useEffect(() => {
    if (useExternalState && nuevaCotizacion) {
      setLocalCotizacion(nuevaCotizacion.cotizacion || '');
      setLocalComentario(nuevaCotizacion.comentariocotizacion || '');
    }
  }, [useExternalState, nuevaCotizacion]);

  //programar escape para cerrar
  useEffect(() => {
    // Función que se ejecuta cuando se presiona una tecla
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        onClose(); // Llama a la función para cerrar el modal
      }
    };

    // Añadir el event listener solo si el modal está visible
    if (showModal) {
      window.addEventListener('keydown', handleEscapeKey);
    }

    // Función de limpieza: se ejecuta cuando el componente se desmonta
    // o antes de que el efecto se vuelva a ejecutar. Es crucial para
    // evitar fugas de memoria.
    return () => {
      window.removeEventListener('keydown', handleEscapeKey);
    };
  }, [showModal, onClose]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Actualizar estado local
    if (name === 'cotizacion') {
      setLocalCotizacion(value.replace(/[^0-9]/g, ''));
    } else if (name === 'comentariocotizacion') {
      setLocalComentario(value);
    }

    // Si hay manejador externo, también llamarlo (para compatibilidad)
    if (useExternalState && onInputChange) {
      onInputChange(e);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      if (useExternalState) {
        // ✅ Modo compatibilidad: usar la función original
        await onSubmit(e);
      } else {
        // ✅ Modo nuevo: pasar valores locales directamente
        await onSubmit(localCotizacion, localComentario);
      }
      
      // Limpiar estado local
      setLocalCotizacion('');
      setLocalComentario('');
      onClose();
    } catch (error) {
      console.error("Error al enviar cotización:", error);
    }
  };

  if (!showModal) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="bg-white p-6 rounded-lg w-96 max-w-md">
        <h2 className="text-xl font-bold mb-4">Cotizar actividad</h2>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="cotizacion" className="block text-sm font-medium text-gray-700 mb-1">
              Precio (solo números)
            </label>

            {/* COTIZACION PRECIO POR NUMEROS, PARA SESORIAS PONER YA PRECIO DADO*/}
            <input
              type="text"
              id="cotizacion"
              name="cotizacion"
              placeholder="Ingrese el precio (solo deben ser numeros)"
              value={localCotizacion}
              onChange={handleInputChange}
              className="border p-2 w-full rounded focus:ring-blue-500 focus:border-blue-500"
              required
              autoComplete="off"
            />
          </div>

          <div className="mb-4">
            <textarea
              name="comentariocotizacion"
              id="comentariocotizacion"
              placeholder="Comentario de cotizacion"
              onChange={handleInputChange}
              value={localComentario}
              className="border p-2 w-full rounded"
              rows={3}
              autoComplete="off"
            />
          </div>   

          <div className="flex justify-end space-x-3">
            <button
              type="submit"
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md shadow-sm text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              Enviar Cotización
            </button>

            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalCotizar;